<template>
  <div id="app">
    <!-- <Header /> -->
    <router-view :key="$route.params.lang" />
    <Footer />
  </div>
</template>

<script>
import Footer from './components/Footer';
// import Header from './components/Header';
import consts from './assets/consts';

export default {
  name: 'app',
  data: function() {
    return {
      url: consts.www,
    }
  },
  metaInfo() {
    return {
      title: this.$i18n.t('meta.title'),
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.$i18n.t('meta.description')
        }
      ]
    };
  },
  components: {
    // Header,
    Footer
  }
}
</script>
